import { useEffect } from "react";
import { Simulation } from "../hooks/simulationData";

export const useDynatrace = (url) => {
    useEffect(() => {
        setTimeout(() => {
            // console.log("enterAction", url || window.location.pathname);
            if (!!window.dtrum) {
                try {
                    const id = window.dtrum.enterAction("customPageview", null, null, url || window.location.pathname);
                    Simulation.set("dynId", id);
                } catch (error) {
                    console.log(error);
                }
            }
        }, 100);

        return () => {
            // console.log("leaveAction", Simulation.get("dynId"));
            if (!!window.dtrum) {
                try {
                    window.dtrum.leaveAction(Simulation.get("dynId"));
                } catch (error) {
                    console.log(error);
                }
            }
        };
    }, []);

    return {};
};
